import {
  ConsultaSeguimentoPergunta04GostaDeSubirEmEnum,
  ConsultaSeguimentoPergunta04Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-04/model-consultaSeguimentoPergunta04'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS, splitHeaderAndPerguntas } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta04Model {
  header: MchatRfAplicacaoQueryModel
  perguntas: MchatRfAplicacaoQueryModel[]
  model: ConsultaSeguimentoPergunta04Model
}

export const convertAplicacaoPergunta04 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta04Model | null => {
  const { header, perguntas } = splitHeaderAndPerguntas(aplicacoes, MChatPerguntaEnum.PERGUNTA_04_01)
  if (header === undefined) return null

  return {
    header,
    perguntas,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_04_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_04_GOSTA_DE_SUBIR_EM: convertAplicacoesToGostaDeSubirEm(perguntas),
    },
  }
}

const convertAplicacoesToGostaDeSubirEm = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta04GostaDeSubirEmEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta04GostaDeSubirEmEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_GOSTA_DE_SUBIR_EM }
  )

const EMPTY_GOSTA_DE_SUBIR_EM: Record<ConsultaSeguimentoPergunta04GostaDeSubirEmEnum, undefined> = {
  [ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.ESCADAS]: undefined,
  [ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.CADEIRAS]: undefined,
  [ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.MOVEIS]: undefined,
  [ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.BRINQUEDOS]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta04GostaDeSubirEmEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_04_02]: ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.ESCADAS,
  [MChatPerguntaEnum.PERGUNTA_04_03]: ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.CADEIRAS,
  [MChatPerguntaEnum.PERGUNTA_04_04]: ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.MOVEIS,
  [MChatPerguntaEnum.PERGUNTA_04_05]: ConsultaSeguimentoPergunta04GostaDeSubirEmEnum.BRINQUEDOS,
}
